// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_UeM","cls2":"News-cls2_fV7 News-cls1_UeM"};